export const getClockOutFlowEnabled = (state) => {
  return state?.companySettings?.clockOutFlowEnabled ?? true;
};
